module.exports = __webpack_public_path__ + "static/media/arrow-up.c54f1371.svg";